<template>
  <SectionContentLayout :state="'success'" content_class="kids-auth">

    <template #header>
      <h2 class="title">{{ Language.say('settings.kids.form_fields.auth.title') }}</h2>
    </template>

    <template #content_success>
      <form v-if="wizard_step == 'submit_alias'" @submit.prevent="onActionSubmitAlias">
        <p class="bottom-space">{{ Language.say('settings.kids.form_fields.auth.description') }}</p>
        <fieldset>
          <InputText
            input_id="input_recipient"
            label_text="settings.kids.form_fields.auth.account.description"
            input_name="recipient"
            :input_required="true"
            :input_invalids="properties_validation.invalid"
            v-model:input_value="recipient_input"
            :input_focus="true"
            @change="properties_validation.validateField('recipient', recipient_input)" />
        </fieldset>
        <div class="submit-desktop top-space">
          <ActionButton
            class="main-action"
            text="settings.kids.form_fields.auth.account.button_actions.submit"
            :loading="props.kids_controller.state.events['submit_alias'] === 'loading'"
            @click='onActionSubmitAlias()' />
        </div>
      </form>
      <!--  -->
      <form v-if="wizard_step == 'secret_passwd'" @submit.prevent="onActionSubmitSecret">
        <p class="bottom-space">
          {{ Language.say('settings.kids.form_fields.auth.description') }}
        </p>
        <fieldset>
          <InputText
            input_id="input_secret"
            :label_text="`settings.kids.form_fields.auth.secret.description.${props.kids_controller.data.auth_parent_method}`"
            input_name="secret"
            :input_type="props.kids_controller.data.auth_parent_method === 'USERPW' ? 'password' : 'text'"
            :input_required="true"
            :input_invalids="properties_validation.invalid"
            v-model:input_value="secret_input" :input_focus="true"
            @change="properties_validation.validateField('secret', secret_input)" />
        </fieldset>
        <div class="submit-desktop top-space">
          <ActionButton
            :text="Language.say('settings.kids.form_fields.auth.secret.button_actions.back')"
            @click="onBackSubmitAlias()" />
          <ActionButton
            class="main-action"
            :text="Language.say('settings.kids.form_fields.auth.secret.button_actions.submit')"
            :loading="props.kids_controller.state.events['submit_secret'] === 'loading'"
            @click="onActionSubmitSecret()" />
        </div>
      </form>
    </template>
  </SectionContentLayout>
</template>

<script setup>
import { defineEmits, ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import ActionButton from '@/vue/Elements/Buttons/ActionButton.vue';
import Language from '@/js/Shared/Language/Language.js';
import InputText from '@/vue/Elements/Inputs/InputText'
import SectionContentLayout from '@/vue/Layouts/Sections/SectionContentLayout.vue';
import PropertiesValidation from '@/js/Shared/Validation/PropertiesValidation.js'

const props = defineProps({
  kids_controller: {
    type: Object,
    required: true
  }
});

const recipient_input = ref('');
const secret_input = ref('');
const wizard_step = ref('submit_alias');
const router = useRouter();
const properties_validation = reactive(new PropertiesValidation({
  recipient: {
    required: true
  },
  secret: {
    required: true
  },
}));

const onActionSubmitAlias = async () => {
  const response = await submitAlias();
  nextStepWizard(response, 'secret_passwd')
}

const onActionSubmitSecret = async () => {
  const response = await submitSecret();

  if (!response) {
    return;
  }

  redirectRouterSettings();
}

const onBackSubmitAlias = () => {
  resetSecret();
  setWizardStep('submit_alias');
}

const submitAlias = async () => {
  if (properties_validation.validateField('recipient', recipient_input.value) === false) {
    return false;
  }

  let success = await props.kids_controller.submitAlias(recipient_input.value);

  return success;
}

const submitSecret = async () => {
  if (properties_validation.validateField('secret', secret_input.value) === false) {
    return false;
  }

  let success = await props.kids_controller.submitSecret(recipient_input.value, secret_input.value);

  return success;
}

const redirectRouterSettings = () => {
  router.push('/settings/kids')
}

const nextStepWizard = (response, next_step) => {
  if (!response) {
    return;
  }

  setWizardStep(next_step);
}

const setWizardStep = (value) => {
  wizard_step.value = value;
}

const resetSecret = () => {
  secret_input.value = '';
}
</script>
